<template>
    <sa-page-layout @refresh="onRefresh" :btnRefreshVisible="true" :showModalLoading="showModalLoading" :btnConfigurazioniVisible="btnConfigurazioniVisible" :pathResource="pathResourceSpecializzazionePai" :linkConfigurazioni="linkConfigurazioni">
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickNuovaSpecializzazionePai">
                <b-icon icon="plus"></b-icon>
                Nuovo
            </b-button>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Ruolo</label>
                        <b-form-select v-model="filtroSpecializzazionePai.idRuolo" type="search" :options="ruoliOptions" value-field="id" text-field="ruolo" value="''">
                            <template #first>
                                <b-form-select-option :value="null" disabled> - Seleziona Ruolo - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Specializzazione</label>
                        <b-form-input v-model="filtroSpecializzazionePai.specializzazione" type="search" id="specializzazione" placeholder="Inserire specializzazione"></b-form-input>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info"> {{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" variant="danger" v-on:click="onReset"> {{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>

        <template slot="table-body">
            <rsa-pai-specializzazione-list-component ref="cmpRsaSpecializzazionePaiList" @afterLoadData="onAfterLoadData" @beforeLoadData="onBeforeLoadData" @updateFilter="onUpdateFilter" />
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaPaiSpecializzazioneListComponent from "../components/RsaPaiSpecializzazioneListComponent.vue";
export default {
    components: { SaPageLayout, RsaPaiSpecializzazioneListComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            btnConfigurazioniVisible: true,
            pathResourceSpecializzazionePai: "",
            pathResourcePaiRuoli: "/rsapairuoli",
            ruoliOptions: [],
            linkback: "",
            linkConfigurazioni: "/configurazioni",
            linkedit: "",
            filtroSpecializzazionePai: { idRuolo: null, specializzazione: null },
            showModalLoading: false,
        };
    },

    mounted() {
        let me = this;
        me.loadRuoliPaiData();
        me.loadData();
    },

    methods: {
        loadData() {
            let me = this;
            me.$refs.cmpRsaSpecializzazionePaiList.loadData();
        },
        loadRuoliPaiData() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourcePaiRuoli, null, me.loadRuoliPaiDataSuccess, me.loadRuoliPaiDataError);
            me.$emit("LoadRuoliPaiData");
        },

        loadRuoliPaiDataSuccess(response) {
            let me = this;
            me.ruoliOptions = response.data.data.list;
            me.ruoliOptions.unshift({ id: null, ruolo: "TUTTI" });
        },
        loadRuoliPaiDataError(error) {
            console.log("Errore durante il caricamento di loadRuoliPaiDataError :", error);
        },

        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },

        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroSpecializzazionePai"] = JSON.stringify(me.filtroSpecializzazionePai);
            me.loadData();
            /* console.log("onSubmitPage: ", this.filtroSpecializzazionePai); */
        },
        onReset() {
            let me = this;
            me.filtroSpecializzazionePai = { specializzazione: null, idRuolo: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroSpecializzazionePai"] = JSON.stringify(me.filtroSpecializzazionePai);
            me.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onClickNuovaSpecializzazionePai() {
            let me = this;
            me.$refs.cmpRsaSpecializzazionePaiList.nuovaSpecializzazionePai();
        },
        onSaveSpecializzazionePai() {
            let me = this;
            me.loadData();
        },
        onUpdateFilter(filterData) {
            this.filtroSpecializzazionePai = filterData;
        },
    },
};
</script>
